import { render, staticRenderFns } from "./Stempelkarte.vue?vue&type=template&id=364101b4&scoped=true"
import script from "./Stempelkarte.vue?vue&type=script&lang=js"
export * from "./Stempelkarte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364101b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364101b4')) {
      api.createRecord('364101b4', component.options)
    } else {
      api.reload('364101b4', component.options)
    }
    module.hot.accept("./Stempelkarte.vue?vue&type=template&id=364101b4&scoped=true", function () {
      api.rerender('364101b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/stempelkarte/Stempelkarte.vue"
export default component.exports